import State from 'store/State';
import { useShallowEqualSelector } from 'utils/hooks/useShallowEqualSelector';
import { useSelector } from 'react-redux';
import { environment } from 'environment';

export const selectLoginState = (state: State) => state.login;

export const useLoginStateSelector = () =>
    useShallowEqualSelector(selectLoginState);

export const selectAuthorities = (state: State) =>
    selectLoginState(state).result?.auths;

export const userHasAllRequiredAuthorities = (
    state: State,
    requiredAuthorities: string[]
) => {
    const authorities = selectAuthorities(state);

    if (environment.isDevMode) {
        return true;
    }

    return (
        authorities && requiredAuthorities.every((r) => authorities.includes(r))
    );
};

export const useSelectUserHasAuthority = (authority: string) => {
    const authorities = useSelector(selectAuthorities);

    if (environment.isDevMode) {
        return true;
    }

    return authorities?.includes(authority);
};
